import React from 'react';
import { showWarningModal } from '../components/modal';
import { Block, Text } from '../components/typography';
import styled from 'styled-components';
import { PropsFrom } from '../types';

export const showAnonymousKioskAmountExceededModal = ({
  title,
  action,
  context,
  kioskAnonymousLimitAmount
}: PropsFrom<typeof MessageComponent> & {
  title: string;
}) =>
  showWarningModal({
    title,
    content: <MessageComponent {...{ kioskAnonymousLimitAmount, action, context }} />
  });

const MessageComponent = ({
  context,
  action,
  kioskAnonymousLimitAmount
}: {
  kioskAnonymousLimitAmount: string;
  context: string;
  action: string;
}) => {
  return (
    <BlockWrapper>
      <Text size="lg" weight="bold">
        You have tried to exceed the maximum {action} of <RedText>{kioskAnonymousLimitAmount}</RedText> allowed{' '}
        {context}.
      </Text>
    </BlockWrapper>
  );
};

const BlockWrapper = styled(Block)`
  width: 40rem;
  margin-top: 1rem;
`;

const RedText = styled(Text)`
  color: ${({ theme }) => theme.colors.red};
`;

export const forTestsOnly = {
  MessageComponent
};
